import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { openFileDialog } from "@Shared/@Utils/utils";
import { mapActions } from "vuex";
import { DOWNLOAD_DOCUMENT } from "@Broker/@Modules/clients/applications/documents/store/documents-actions";
import InlineLoader from "@Shared/components/general/inline-loader.vue";
import CollapsibleCard from "@Broker/@Modules/clients/board/client-profile/components/shared/collapsible-card.vue";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "UploadedDocuments",
  components: {
    InlineLoader,
    CollapsibleCard
  },
  props: {
    documents: {
      type: Array,
      default: () => []
    },
    username: {
      type: String,
      required: true
    },
    collapse: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      downloadingDocument: {}
    };
  },
  methods: _objectSpread(_objectSpread({}, mapActions("DocumentsStore", [DOWNLOAD_DOCUMENT])), {}, {
    last(index) {
      return index === _Object$keys(this.documents).length - 1;
    },
    formatTimeAgo(value) {
      return this.$options.filters.formatTimeAgo(value);
    },
    async handleDownloadDocument(applicationId, documentId, fileName) {
      if (this.downloadingDocument[documentId]) return;
      this.$set(this.downloadingDocument, documentId, true);
      const {
        url
      } = await this.DOWNLOAD_DOCUMENT({
        clientUsername: this.username,
        applicationId,
        fileName,
        documentId
      });
      openFileDialog(url, fileName);
      this.$set(this.downloadingDocument, documentId, false);
    }
  })
});